<div class="super-admin-careers">
  <div class="d-flex justify-content-between align-items-center mt-0 careers-table">
    <div class="pb-4">
      <h2 class="page-heading">All Jobs</h2>
    </div>

    <div class="d-flex career-management-header m-2">
      <mat-form-field appearance="outline" class="m-2 mr-1 search-bar">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput placeholder="Search" (input)="onSearch($event)" [value]="searchValue">
        <button *ngIf="searchValue" matSuffix mat-icon-button aria-label="Clear" class="search-remove-container" (click)="onSearch('')">
          <mat-icon class="distributor-search-clear">close</mat-icon>
        </button>
      </mat-form-field>
      <button class="header-btn m-2 mr-1 export-btn" mat-raised-button (click)="exportallJobs()">
        <img src="assets/images/icons/Export.svg" alt=""> Export
      </button>
      <button class="header-btn m-2 mr-1 filter-btn" mat-raised-button (click)="openFilter()">
        <img src="assets/images/filter.svg" alt=""> Filter
      </button>
      <button *ngIf="hasAddPermission" class="header-btn m-2 add-career-btn" mat-raised-button (click)="selectedAction({ action: MweConstants.addAction })">
        <img src="assets/images/icons/vector.svg" alt=""> Post A Job
      </button>
    </div>
  </div>
  <div *ngIf="chips?.length" class="d-flex flex-row align-items-center row-container-2 p-1 mb-3  career-filters">
    <div>
      <span class="paragraph-medium">Filters applied: </span>
      <mat-chip class="chip-item" *ngFor="let chip of chips" (removed)="removeChip(chip)">
        {{ chip?.name }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
    </div>
    <div>
      <button class="mwe-button mwe-button--primary ps-3 pe-3 mx-3" (click)="clearAll()">Clear all</button>
    </div>
  </div>

  <div  class="summary-container">
    <div *ngFor="let object of objects" class="block">
        <div class="inside-block">
            <img [src]="object.image" alt="">
            <div class="detailed-summary">
                <h2 class="summary-text">{{ object.name }}</h2>
                <h1 class="summary-count">{{ object.count }}</h1>

            </div>
        </div>

    </div>
</div>

  <div class="careers">
    <app-mwe-table
      [columns]="columns"
      [showHeader]="true"
      [data]="data"
      [exportTitle]="'Jobs'"
      [initialSearchValue]="searchValue"
      (selectedAction)="selectedAction($event)"
      (pageChanged)="onPageChange($event)"
      [isDynemicPagination]="isPagination"
      [currentPageChanged]="page"
      [totalEntries]="totalEntries"
      [dynamicPageSize]="pageSize"
      [showPagination]="showPagination">
    </app-mwe-table>
  </div>
</div>
